import { Toiminto } from "@/enums";
import { defineMultiTextBox } from "@/graphHandling/components/multiTextBox/definition";
import { TietueProps } from "@/graphHandling/components/multiTextBox/MultiTextBox";
import { CellFn } from "@/graphHandling/graphTypes";
import common from "@/i18n/definitions/common";
import { Lupa } from "@/Lupa";
import {
  filter,
  has,
  isEmpty,
  isNil,
  map,
  mergeAll,
  path,
  propEq,
  reject
} from "ramda";
import { Muutos, Muutospyynto } from "@/types";
import { KOODISTOT } from "@/utils/constants";
import { Properties } from "@/utils/lomakkeet";

export const initialize_multiTextBox: CellFn = (storeFunctions, intl) => {
  if (!intl) {
    console.warn("Parametri intl puuttuu.");
    return false;
  }

  let muutokset: Array<Muutos> = [];
  let multiTextBoxMuutokset: Array<Muutos> = [];
  let luvanTietueet: Record<string, TietueProps> = {};

  const custom = storeFunctions.readPath(["custom"]) as Properties;

  const viimeisinLupa = custom.viimeisinLupa as Lupa;

  const muutospyynto = custom.muutospyynto as Muutospyynto;

  if (muutospyynto) {
    muutokset = muutospyynto.muutokset;
    multiTextBoxMuutokset = filter(muutos => {
      return (
        muutos.koodisto === KOODISTOT.OIVA_MUUT && muutos.koodiarvo === "22"
      );
    }, muutokset);
  }

  const tietueet: Record<string, TietueProps> = {};

  if (viimeisinLupa) {
    luvanTietueet = mergeAll(
      reject(
        isNil,
        map(maarays => {
          if (
            maarays.koodisto === KOODISTOT.OIVA_MUUT &&
            maarays.koodiarvo === "22"
          ) {
            const createdAt = new Date();
            const id = maarays.uuid;
            return {
              [id]: {
                createdAt,
                id,
                placeholder: intl.formatMessage(common.kuvausPlaceholder),
                title: intl.formatMessage(common.kuvaus),
                value: maarays.meta?.value as string
              }
            };
          }
          return null;
        }, viimeisinLupa.maaraykset)
      )
    );
  }

  let modifications = {};

  if (!isEmpty(multiTextBoxMuutokset)) {
    let modifiedTietueet: Record<string, TietueProps> = mergeAll(
      reject(
        isNil,
        map(muutos => {
          const createdAt = new Date();
          const id = (path(["meta", "maaraysUuid"], muutos) ||
            path(["meta", "ankkuri"], muutos)) as string;
          return {
            [id]: {
              createdAt,
              id,
              isDeleted: muutos.tila === Toiminto.POISTO,
              placeholder: intl.formatMessage(common.kuvausPlaceholder),
              title: intl.formatMessage(common.kuvaus),
              value: muutos.meta?.value ? String(muutos.meta?.value) : ""
            }
          };
        }, multiTextBoxMuutokset)
      )
    );

    modifiedTietueet = Object.assign({}, luvanTietueet, modifiedTietueet);

    modifications = {
      backend: {
        tietueet: modifiedTietueet
      }
    };
  }

  if (isEmpty(tietueet)) {
    mergeAll(
      map(muutos => {
        const createdAt = new Date();
        const id = `multiTextBox-first`;
        return {
          [id]: {
            createdAt,
            id,
            placeholder: intl.formatMessage(common.kuvausPlaceholder),
            title: intl.formatMessage(common.kuvaus),
            value: muutos.meta?.arvo || ""
          }
        };
      }, multiTextBoxMuutokset)
    );
  }

  const createdAt = new Date();
  const oletustietueenId = `multiTextBox-${Math.random()}`;

  // Jos lupa ei sisällä yhtään tietuetta, luodaan yksi tietue, jotta
  // käyttäjän ei tarvitsisi heti painaa lisäyspainiketta.
  const oletustietueet = {
    [oletustietueenId]: {
      createdAt,
      id: oletustietueenId,
      placeholder: intl.formatMessage(common.kuvausPlaceholder),
      title: intl.formatMessage(common.kuvaus),
      value: ""
    }
  };

  const backendChanges: Record<string, TietueProps> | undefined = path(
    ["backend", "tietueet"],
    modifications
  );

  const tietueitaBackendMuutoksienMyota = !isEmpty(
    filter(
      (tietue: TietueProps) =>
        (has("isDeleted", tietue) && propEq("isDeleted", false, tietue)) ||
        !has("isDeleted", tietue),
      backendChanges || {}
    )
  );
  return defineMultiTextBox(
    {
      tietueet:
        isEmpty(luvanTietueet) && !tietueitaBackendMuutoksienMyota
          ? oletustietueet
          : luvanTietueet,
      isVisible: true
    },
    {
      onChange: payload => {
        return payload;
      }
    },
    modifications
  );
};
